<template>
	<div>
		<vue-mathjax
			class="latex__formula"
			:formula="formula"
		/>
		<div style="display: flex; flex-direction: column">
			<v-chip
				v-for="(beta, i) in modeloEscolhido.parametros"
				:key="beta"
				style="width: auto; margin: 5px auto"
				@click="copiaBeta($event)"
			>
				{{ betaLabels[i] }} = {{ beta }}
			</v-chip>
			<v-chip
				color="#95bb49"
				style="width: auto; margin: 5px auto"
				@click="copiaTudo()"
			>
				Copiar Todos
			</v-chip>
		</div>
		<div
			v-show="false"
			id="copyBetas"
		>
			<v-chip
				v-for="(beta, i) in modeloEscolhido.parametros"
				v-show="false"
				:key="beta"
				style="width: auto; margin: 5px auto"
				@click="copiaBeta($event)"
			>
				{{ betaLabels[i] + '\t' }} {{ parseFloat(beta).toString().replace('.', ',') + '\n' }}
			</v-chip>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
	props: {
		modeloEscolhido: {
			type: Object,
			required: true,
		},
		formula: {
			type: String,
			required: true,
		},
	},
	computed: {
		betaLabels() {
			const totalParametros = this.modeloEscolhido?.parametros?.length || 0
			const formulaResolvida = this.formula || ''
			const usaClutterBasal = /b_0/.test(formulaResolvida) && /a_1/.test(formulaResolvida)
			if (usaClutterBasal) return ['b₀', 'b₁', 'b₂', 'b₃', 'α₁', 'α₂']
			return Array.from({ length: totalParametros }, (_, i) => `β${i + 1}`)
		},
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		copiaBeta(e) {
			navigator.clipboard.writeText(e.target.innerHTML.split('=')[1].trim())
			this.mutationShowMessage({
				messageTitle: this.$t('sucesso'),
				messageText: this.$t('betaCopiadoParaAreaDeTransferencia'),
				messageIcon: 'far fa-check-circle',
				messageType: 'success',
			})
		},
		copiaTudo() {
			var range = document.createRange()
			range.selectNode(document.getElementById('copyBetas'))
			// let content = 'Formula \t Beta \n' +this.formula +'\t'+ this.modeloEscolhido.parametros.toString();
			// navigator.clipboard.writeText(content)

			navigator.clipboard.writeText('Formula \t' + this.formula + '\n' + range)

			this.mutationShowMessage({
				messageTitle: this.$t('sucesso'),
				messageText: this.$t('informacoesCopiadasParaAreaDeTransferencia'),
				messageIcon: 'far fa-check-circle',
				messageType: 'success',
			})
		},
	},
}
</script>

<style scoped>
.latex__formula {
	margin: 1px;
	display: block;
	max-width: 100%;
}
</style>
